/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export const DEFAULT_SEAT_PRICE_TEMPLATE = "{{pricePerSeat}}";
export const DEFAULT_UE_SEAT_PRICE_NUM = 1850;
export const DEFAULT_UE_SEAT_PRICE_STR = "$1,850";
export const DEFAULT_UE_SEAT_PURCHASE_QUERY_PARAMS =
	"?namespace=unreal-engine&purchase-subscription=unreal-engine&type=license-purchase&quantity=";
